export default {
  di_account: 'Tài khoản',
  inventory_item: 'Vật tư',
  di_accounting_object: 'Cán bộ',
  bu_plan_with_draw: 'Số chứng từ',
  di_budget_source: 'Nguồn',
  di_budget_chapter: 'Chương',
  di_budget_kind_item: 'Loại - Khoản',
  di_budget_item: 'Mục/Tiểu mục',
  di_budget_group_item: 'Nhóm mục chi',
  di_budget_source_property: 'Tính chất nguồn kinh phí',
  di_fund: 'Loại Quỹ',
  di_bank_info_category: 'Loại tài khoản tiền gửi kho bạc',
  di_bank_info: 'Tài khoản ngân hàng, kho bạc',
  di_statistic: 'Mã thống kê',
  di_currency: 'Loại tiền',
  di_department: 'Phòng/ban',
  di_purchase_purpose: 'Nhóm hàng hóa - dịch vụ',
  di_account_transfer: 'Tài khoản kết chuyển',
  di_stock: 'Kho',
  di_auto_business: 'Định khoản tự động',
  ba_withdraw: 'Chi tiền gửi',
  ba_bank_transfer: 'Chuyển tiền nội bộ',
  ba_deposit: 'Thu tiền gửi',
  ca_payment: 'Phiếu chi',
  ca_receipt: 'Phiếu thu',
  bu_budget_reserve: 'Dự toán giữ lại',
  bu_plan_receipt: 'Nhận dự toán',
  bu_plan_adjustment: 'Điều chỉnh dự toán',
  ca_receipt: 'Phiếu thu bán hàng',
  gl_voucher: 'Chứng từ nghiệp vụ khác',
  gl_voucher_list: 'Bảng tổng hợp chứng từ cùng loại',
  sa_invoice: 'Bán hàng chưa thu tiền',
  di_activity: 'Hoạt động',
  di_task: 'Nhiệm vụ',
  di_budget_fees: 'Phí, lệ phí',
  di_accounting_object_category: 'Loại khách hàng, nhà cung cấp',
  di_invoice_form_number: 'Mẫu số hóa đơn',
  di_voucher_type: 'Loại chứng từ',
  bu_commitment_request: 'Đề nghị cam kết chi',
  bu_commitment_adjustment: 'Điều chỉnh cam kết chi',
  bu_opening_commitment: 'Nhập cam kết chi ban đầu',
  di_project: 'Chương trình mục tiêu, dự án',
  di_project_budget_detail: 'Chi tiết dự toán kinh phí',
  bu_plan_import: 'Nhập dự toán',
  opening_supply_entry: 'Công cụ dụng cụ ban đầu',
  di_contract: 'Hợp đồng',
  di_auto_business: 'Định khoản tự động',
  di_fund_structure: 'Cơ cấu vốn',
  cre_rep_list: 'Bảng lập báo cáo tài chính, bc quyết toán',
  cre_rep_export_list: 'Nộp báo cáo cho kho bạc',
};
